import axios from "axios"
import { Message } from "element-ui"
import router from "@/router"

const FRONT_API_BASE = process.env.VUE_APP_FRONT_API_BASE

/**
 * 显示自动关闭的请求错误提示
 * @param {string} message 错误提示内容
 * @returns {Object} Element Message 实例
 */
function showRequestError(message) {
  Message.closeAll()
  return Message({
    type: 'error',
    message,
    duration: 1800,
    showClose: false
  })
}

const service = axios.create({
  baseURL: FRONT_API_BASE,
  timeout: 20000,
  withCredentials: true
})

// request 拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('front_token')
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  () => Promise.resolve(null)
)

// response 拦截器（重点）
service.interceptors.response.use(
  response => {
    const res = response.data

    if (!res) {
      showRequestError('服务器返回数据异常')
      return null
    }

    // 处理401未授权
    if (res.status === 401) {
      showRequestError('登录已过期，请重新登录')
      localStorage.removeItem('front_token')
      router.push('/login')
      return { __success: false }
    }

    const success = res.status === 200 
    if (!success) {
      showRequestError(res.msg || '请求失败')
      return {
        __success: false,
        status: res.status,
        message: res.msg || '',
        errorType: res.data && res.data.errorType ? res.data.errorType : '',
        data: res.data || null
      }
    }

    return {
      __success: true,
      data: res.data ?? res
    }     // ✅ 只把成功结果交给 then
  },
  error => {
    // 处理401未授权
    if (error.response?.status === 401) {
      showRequestError('登录已过期，请重新登录')
      localStorage.removeItem('front_token')
      router.push('/login')
      return { __success: false }
    }

    const msg =
      error.response?.data?.msg ||
      error.response?.data?.message ||
      error.message ||
      '网络请求失败'

    showRequestError(msg)

     return { __success: false }
  }
)

export default service
